import { IItem, SignItem } from "../../../../domain/document/items";
import { BeanTypes, ISignItemBean, ITypeDefinable } from "../beans/items";
import { AbstractImageItemTranslator } from "./AbstractImageItemTranslator";

export class SignItemTranslator extends AbstractImageItemTranslator<SignItem, ISignItemBean> {
  constructor(getToken: () => string) {
    super(getToken, BeanTypes.Sign);
  }

  protected craeteItem(): SignItem {
    return new SignItem();
  }

  toItem(source: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = source as ISignItemBean;
    const item = super.toItem(bean, formatId, groupId, documentId, executionMode) as SignItem;
    item.signatureGuid = bean.signatureGuid;
    item.signatureCacheGuid = null; // signatureCacheGuidは不要
    return item;
  }

  toBean(item: IItem): ISignItemBean {
    const target = item as SignItem;
    const bean = super.toBean(item) as ISignItemBean;
    bean.signatureGuid = target.signatureGuid;
    bean.signatureCacheGuid = target.signatureCacheGuid;
    return bean;
  }
}
